import { useState } from 'react'

/**
 * Zeigt einen langen Wert zum Kopieren, etwa den Installationsbefehl. Der Wert
 * steht immer sichtbar da; die Schaltfläche ist nur eine Abkürzung.
 */
export function CopyField({ label, value }: { label: string; value: string }) {
  const [copied, setCopied] = useState(false)

  return (
    <div className="field">
      <label htmlFor={`copy-${label}`}>{label}</label>
      <div className="row" style={{ alignItems: 'stretch', gap: 8 }}>
        <textarea
          id={`copy-${label}`}
          className="input mono"
          readOnly
          value={value}
          rows={2}
          style={{ height: 'auto', padding: '8px 12px', resize: 'vertical', lineHeight: 1.5 }}
          onFocus={(e) => e.currentTarget.select()}
        />
        <button
          type="button"
          className="btn"
          onClick={() => {
            void navigator.clipboard
              ?.writeText(value)
              .then(() => {
                setCopied(true)
                setTimeout(() => setCopied(false), 2000)
              })
              .catch(() => setCopied(false))
          }}
        >
          {copied ? 'Kopiert' : 'Kopieren'}
        </button>
      </div>
    </div>
  )
}
